import {Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useMail} from "../../context/MailboxContext";


const ShowMail = ({tabsName}) => {
    const navigate = useNavigate();
    const [selectedMails, setSelectedMails] = useState(0)
    const {mails, mailConversation, fetchMailConversation} = useMail()
    let { id } = useParams();


    useEffect(() => {
        if (mails) {
            fetchMailConversation(id)

            setSelectedMails(mails.find(mail => mail.find(m => m.id === parseInt(id))))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, mails]);

    useEffect(() => {
        if (mailConversation) {
            setSelectedMails(mailConversation)
        }
    }, [mailConversation]);

    const handleClose = () => {
        navigate('/mailbox/received')
    }

    return (
        <Modal
            show={true}
            onHide={handleClose}
            size="xl"
            fullscreen="xxl-down"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Titre
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                {selectedMails && Object.keys(selectedMails).map(key => (
                    <div className={`d-flex align-items-start mailbox-mail direction-${selectedMails[key].direction}`}>
                        <div className="flex-grow-1">
                            <div className="mailbox-sent-from">
                                <strong>{selectedMails[key].sentFrom}</strong> - <small className="text-muted">{selectedMails[key].sentAt}</small>
                            </div>


                            <div className="text-sm text-muted mt-1 mailbox-mail-content">
                                <div className="mailbox-infos">
                                    <div className="mailbox-subject">Objet: <strong>{selectedMails[key].subject}</strong></div>
                                    {selectedMails[key].sendTo && <div className="mailbox-to">To: <strong>{selectedMails[key].sendTo}</strong><br/></div> }
                                    {selectedMails[key].sendToCC && <div className="mailbox-cc">CC: <strong>{selectedMails[key].sendToCC}</strong><br/></div> }
                                </div>
                                <div dangerouslySetInnerHTML={{__html: selectedMails[key].content}}></div>
                            </div>
                        </div>
                    </div>
                ))}
            </Modal.Body>
        </Modal>
    )
}

export default ShowMail